$(document).ready(function() {
    

        changeFlag();
        
        $( ".de-ColorSwatches-color" ).click(function() {
            changeFlag();
            
            setTimeout(closeList, 1);

        });
    
});

function closeList(){
    $(".product__buybox_sizes_list_opened").removeClass("product__buybox_sizes_list_opened");
}
function productImageChange(){
    $("#Galery-Product-Image").load(location.href + " #Galery-Product-Image");
}
function changeFlag() {
    var productFirstSize = document.querySelector("#productBuyBox > div > section > div > div.de-ProductPageTopShelf-sizeSwatches > div.product__buybox_select_size.de-SwatchObjects.js-de-SizeSwatches > ul > button:nth-child(1)")
    var priceTypePromo =  productFirstSize.dataset.priceType;
    const flagEl = $('.js-de-ProductFlag');
    if(document.querySelector("#productBuyBox > div > section > div > div.de-ProductPageTopShelf-sizeSwatches > div.product__buybox_select_size.de-SwatchObjects.js-de-SizeSwatches > ul > button:nth-child(2)") == null){
        switch(priceTypePromo) {
            case "STANDARD": 
            $(flagEl).hide();
            $(flagEl).text("STANDARD");
            break;
            case "DAY_TO_DAY_PROMOTION": 
            $(flagEl).show();
            $(flagEl).text("Promoción");
            break;
            case "SEASON_SALES": 
            $(flagEl).show();
            $(flagEl).text("En oferta");
            break;
            
            default:
            $(flagEl).hide();
            break;
            }

    }else{

    
        if(document.querySelector(".js-de-SizeSwatches-option.de-is-active") == null){
        switch(priceTypePromo) {
        case "STANDARD": 
        $(flagEl).hide();
        $(flagEl).text("STANDARD");
        break;
        case "DAY_TO_DAY_PROMOTION": 
        $(flagEl).show();
        $(flagEl).text("Promoción");
        break;
        case "SEASON_SALES": 
        $(flagEl).show();
        $(flagEl).text("En oferta");
        break;
        
        default:
        $(flagEl).hide();
        break;
        }
    }
    }
}